import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { 
    Box, 
    Grid, 
    Card, 
    CardActionArea, 
    CardContent, 
    Typography, 
    Avatar, 
    CircularProgress, 
    Chip, 
    Paper
} from '@mui/material';

// Asegúrate de importar tu controlador
import { getWorkspaces } from '../../../controllers/customer/workspaces/WorkspacesController';

export default function WorkspacesSelection() {
    const history = useHistory();
    const [workspaces, setWorkspaces] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchWorkspaces = async () => {
            let response = await getWorkspaces();
            if (response && response.success && response.data.workspaces) {
                setWorkspaces(response.data.workspaces);
            }
            setLoading(false);
        };

        fetchWorkspaces();
    }, []);

    const handleSelectWorkspace = (merchantId) => {
        // Guardamos en local para acceso rápido global si hace falta
        localStorage.setItem('work_mode_merchant_id', merchantId);
        // Usamos tu nueva estructura de ruta
        history.push(`/workspaces/${merchantId}`);
    };

    // Función para obtener la inicial del nombre si no hay logo
    const getInitials = (name) => {
        if (!name) return '';
        return name.charAt(0).toUpperCase();
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                <CircularProgress />
            </Box>
        );
    }

    if (workspaces.length === 0) {
        return (
            <Box textAlign="center" mt={5}>
                <Typography variant="h6" color="text.secondary">
                    No tienes espacios de trabajo asignados.
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1200, margin: '0 auto' }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
                Tus Workspaces
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={4}>
                Selecciona la empresa con la que vas a operar hoy.
            </Typography>

            <Grid container spacing={3}>
                {workspaces.map((workspace) => 
                    <Grid item xs={12} sm={12} md={6} lg={4} key={workspace.employee_record_id}>
                        <Card
                            elevation={2}
                            sx={{ 
                                //height: '100%',
                                borderRadius: '12px',
                                border: '1px solid #e0e0e0', // Borde sutil como en tu paleta
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    borderColor: 'primary.main',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                    transform: 'translateY(-2px)',
                                    cursor:'pointer'
                                }
                            }}
                            onClick={() => handleSelectWorkspace(workspace.merchant_id)}
                        >
                            <CardContent sx={{ p: 0, textAlign: 'center', flexGrow: 1, width: '100%' }}>
                                <Box sx={{display:'flex',flexDirection:'row', justifyContent:'center'}}>
                                    <Avatar 
                                        src={workspace.merchant_image}
                                        alt={workspace.merchant_name}
                                        sx={{ 
                                            width: 72, 
                                            height: 72, 
                                            mb: 2, 
                                            bgcolor: '#bdbdbd', // Color gris por defecto para las letras
                                            color: '#fff',
                                            fontSize: '24px'
                                        }}
                                    >
                                        {/* Muestra la inicial si la imagen falla en local */}
                                        {getInitials(workspace.merchant_name)}
                                    </Avatar>
                                </Box>
                                
                                <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, lineHeight: 1.2 }}>
                                    {workspace.merchant_name}
                                </Typography>
                                
                                <Chip 
                                    label={workspace.position.toUpperCase()} 
                                    variant="outlined" 
                                    size="small" 
                                    sx={{ 
                                        mt: 1, 
                                        fontWeight: 'bold', 
                                        fontSize: '0.7rem',
                                        color: 'text.secondary',
                                        borderColor: '#e0e0e0'
                                    }}
                                />
                         
                            </CardContent>
                        </Card>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
}